import React, { useEffect } from "react";
import { Root } from "@uidaholib/components/lib/root";
import config from "@uidaholib/shared/constants/config";

let title = "";
const mapId = "inside-idaho-elevation-map";
const appName = "imagery";
// const appName = "elevation"

const App = () => {
  useEffect(() => {
    title = config && config.appTitle;
  }, []);

  return <Root mapId={mapId} title={title} appName={appName} />;
};

export default App;
